import { createSlice } from "@reduxjs/toolkit"
import {
  getAttendaceList,
  getCateringList,
  getScheduleList,
  getRoasterRandomCheckList,
} from "store/actions/roasterAction"

const initialPayload = {
  limit: 50,
  page_number: 1,
  order_by: -1,
  filters: {
    day: null, // 1 to 7
    shift: null, // E,L,N
    station: null, // 1 to 9
    keyword: "",
    date_range: [],
    job_title_ids: [], // null, [],[1,2]
  },
}

const cateringInitialPayload = {
  limit: 50,
  page_number: 1,
  order_by: -1,
  filters: {
    keyword: "",
    date_range: [],
    status: null,
  },
}

const attendanceInitialPayload = {
  limit: 50,
  page_number: 1,
  order_by: -1,
  filters: {
    type: 0, //0: for all attendance,1: For present & Complete and 2: For Absent
    attendance_type: 0, //0:all,1: Early Check In,2: Late Check In,3: Early Checkout and 4: Late Checkout
    day: null, // 1 to 7
    shift: null, // E,L,N
    station: null, // 1 to 9
    keyword: "",
    date_range: [],
    attendance_admin_id: null,
    job_title_ids: [], // null, [],[1,2]
  },
}

const inspectionInitialPayload = {
  limit: 50,
  page_number: 1,
  order_by: -1,
  filters: {
    keyword: "",
    date_range: [],
    shift: null,
    station: null,
    attendance_admin_id: null,
    job_title_ids: [],
    type: 0, // 0:All,1:present and 2:Absent
  },
}

const initialState = {
  loading: false,
  loading2: false,
  isLoading: null,
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  attendaceList: [],
  scheduleList: [],
  matchedCandidatesList: [],
  payload: initialPayload,
  allowTrialOperationSchedule: false,
  activeTab: "roaster",
  candidatesActiveTab: 0,
  isShowFilter: false,
  cateringPayload: cateringInitialPayload,
  caterings: [],
  trialPeriodSchedules: [],
  isGettingDetails: false,
  trialOperationDetails: {},
  trialOperationsAttendance: [],
  trialOperationsEnrollments: [],
  trialOperationsReasonList: [],
  randomCheckList: [],
  attendancePayload: attendanceInitialPayload,
  inspectionPayload: inspectionInitialPayload,
}

const roasterSlice = createSlice({
  name: "Roaster",
  initialState,
  reducers: {
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },

    setCateringPayload: (state, action) => {
      state.cateringPayload = { ...state.cateringPayload, ...action.payload }
    },
    resetCateringPayload: state => {
      state.cateringPayload = cateringInitialPayload
    },
    setAttendancePayload: (state, action) => {
      state.attendancePayload = {
        ...state.attendancePayload,
        ...action.payload,
      }
    },
    resetAttendancePayload: state => {
      state.attendancePayload = attendanceInitialPayload
    },
    setInspectionPayload: (state, action) => {
      state.inspectionPayload = {
        ...state.inspectionPayload,
        ...action.payload,
      }
    },
    resetInspectionPayload: state => {
      state.inspectionPayload = inspectionInitialPayload
    },

    resetPayload: state => {
      state.payload = initialPayload
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setCandidatesActiveTab: (state, action) => {
      state.candidatesActiveTab = action.payload
    },
    toggleFilter: state => {
      state.isShowFilter = !state.isShowFilter
    },
  },

  extraReducers: builder => {
    builder
      .addCase(getRoasterRandomCheckList.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
        state.randomCheckList = []
      })
      .addCase(getRoasterRandomCheckList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.randomCheckList = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getRoasterRandomCheckList.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getScheduleList.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
        state.scheduleList = []
      })
      .addCase(getScheduleList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data, settings } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.scheduleList = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getScheduleList.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getAttendaceList.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getAttendaceList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data, settings } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.attendaceList = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getAttendaceList.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getCateringList.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getCateringList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.caterings = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getCateringList.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export const {
  setPayload,
  resetPayload,
  setActiveTab,
  setCandidatesActiveTab,
  toggleFilter,
  setCateringPayload,
  resetCateringPayload,
  setAttendancePayload,
  resetAttendancePayload,
  setInspectionPayload,
  resetInspectionPayload,
  setEnrollmentPayload,
  resetEnrollmentPayload,
  setCandidatesPayload,
  resetCandidatesPayload,
} = roasterSlice.actions
export default roasterSlice.reducer
